(() => {
  const script = document.currentScript;
  if (!script || window.__ohsioAvailabilityReconciler) return;

  const handle = script.dataset.productHandle;
  const country = script.dataset.country;
  const enabledCountries = new Set(
    (script.dataset.enabledCountries || '')
      .split(',')
      .map((code) => code.trim())
      .filter(Boolean),
  );
  const addToCartLabel = script.dataset.addToCartLabel || 'Add to cart';

  if (!handle || !country || !enabledCountries.has(country)) return;
  window.__ohsioAvailabilityReconciler = true;

  let product = null;
  let scheduled = 0;
  let observer = null;

  function selectedVariantId() {
    const urlVariantId = new URL(window.location.href).searchParams.get(
      'variant',
    );
    const checkedId = document.querySelector(
      'main product-form-component input[name="id"]:checked',
    )?.value;
    const formId = document.querySelector(
      'main product-form-component input[name="id"], main product-form-component select[name="id"]',
    )?.value;
    const stickyId = document.querySelector(
      'sticky-add-to-cart[data-product-id]',
    )?.dataset.currentVariantId;
    return String(checkedId || formId || stickyId || urlVariantId || '');
  }

  function selectedAvailableVariant() {
    if (!product?.variants?.length) return null;
    const id = selectedVariantId();
    if (id) {
      const selected = product.variants.find(
        (variant) => String(variant.id) === id,
      );
      if (selected) return selected.available ? selected : null;
    }
    if (product.variants.length === 1 && product.variants[0].available) {
      return product.variants[0];
    }
    return null;
  }

  function unavailableLabel(button) {
    const text = (button.textContent || '').replace(/\s+/g, ' ').trim();
    return /\b(?:sold out|unavailable)\b/i.test(text);
  }

  function updateButton(button) {
    if (!(button instanceof HTMLButtonElement) || !unavailableLabel(button)) {
      return;
    }

    button.disabled = false;
    button.removeAttribute('disabled');
    button.setAttribute('aria-disabled', 'false');
    button.dataset.ohsioAvailabilityReconciled = 'true';

    const content =
      button.querySelector('.add-to-cart-text__content > span > span') ||
      button.querySelector('.add-to-cart-text__content > span') ||
      button.querySelector('.add-to-cart-text__content');
    if (content) content.textContent = addToCartLabel;
  }

  function reconcile() {
    const variant = selectedAvailableVariant();
    if (!variant) return;

    document
      .querySelectorAll(
        'main product-form-component button[name="add"], sticky-add-to-cart button[ref="addToCartButton"]',
      )
      .forEach(updateButton);

    const sticky = document.querySelector(
      'sticky-add-to-cart[data-product-id]',
    );
    if (sticky) {
      sticky.dataset.variantAvailable = 'true';
      sticky.dataset.currentVariantId = String(variant.id);
    }
  }

  function scheduleReconcile(delay = 80) {
    window.clearTimeout(scheduled);
    scheduled = window.setTimeout(reconcile, delay);
  }

  async function loadAvailability() {
    try {
      const url = new URL(`/products/${handle}.js`, window.location.origin);
      url.searchParams.set('country', country);
      url.searchParams.set('availability_check', Date.now().toString());
      const response = await fetch(url, {
        headers: { accept: 'application/json' },
        cache: 'no-store',
      });
      if (!response.ok) return;

      const payload = await response.json();
      if (!payload?.available || !Array.isArray(payload.variants)) return;
      product = payload;
      reconcile();

      document.addEventListener('change', () => scheduleReconcile(700), true);
      document.addEventListener('variant:update', () => scheduleReconcile(100));
      document.addEventListener('variant:change', () => scheduleReconcile(100));

      observer = new MutationObserver(() => scheduleReconcile(50));
      observer.observe(document.querySelector('main') || document.body, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['disabled', 'data-variant-available'],
      });
      window.setTimeout(() => observer?.disconnect(), 12000);
    } catch {
      // Keep the theme's native state if market availability cannot be verified.
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadAvailability, {
      once: true,
    });
  } else {
    loadAvailability();
  }
})();
